import { MapPin, Phone } from "lucide-react";

export const Footer = () => (
  <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-[#262626] py-12">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-6">
      <span className="font-heading text-xl font-bold uppercase tracking-tight text-white">
        Jatt Car <span className="text-[#FF4500]">Modification</span>
      </span>
      <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8 text-sm text-neutral-500">
        <span className="flex items-center gap-2">
          <MapPin size={14} className="text-[#FF4500]" /> 318 Logan Avenue
        </span>
        <a href="tel:2046196003" className="flex items-center gap-2 hover:text-[#FF4500] transition-colors">
          <Phone size={14} className="text-[#FF4500]" /> 204-619-6003
        </a>
      </div>
      <p className="text-xs uppercase tracking-widest text-neutral-600">
        © {new Date().getFullYear()} Jatt Car Modification
      </p>
    </div>
  </footer>
);
